import React from 'react'

import { NotificationItem } from './NotificationItem'
import { UnorderedList, Button, GetMoreWrap } from './styled'

import { INotification } from 'src/api/notifications/types'

interface Props {
  notifications: INotification[]
  total: number
  getMore: () => void
  refetchNotifications: () => void
}

export const NotificationList: React.FC<Props> = ({
  notifications,
  total,
  getMore,
  refetchNotifications,
}) => (
  <>
    <UnorderedList>
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          refetchNotifications={refetchNotifications}
        />
      ))}
    </UnorderedList>
    {notifications.length < total && (
      <GetMoreWrap>
        <Button secondary onClick={getMore}>
          Load more
        </Button>
      </GetMoreWrap>
    )}
  </>
)
